module.exports = __webpack_public_path__ + "static/media/gold-team.9184268c.png";